import { render, staticRenderFns } from "./blockvideo.vue?vue&type=template&id=bcae0100&scoped=true&"
import script from "./blockvideo.vue?vue&type=script&lang=js&"
export * from "./blockvideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcae0100",
  null
  
)

export default component.exports